import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M15.1599 34.48C16.9399 34.98 18.6899 34.9899 20.3299 34.5699C21.1499 34.3399 21.9499 34.02 22.7199 33.61C23.1199 33.42 23.4799 33.16 23.8799 32.95C24.2599 32.71 24.6199 32.44 25.0399 32.21C24.7799 32.6 24.4999 32.9699 24.1999 33.3199C23.8599 33.6399 23.5399 33.99 23.1499 34.26C22.3999 34.85 21.5199 35.26 20.5899 35.53C18.7199 36.01 16.5899 35.71 15.1599 34.48Z"
        fill={outline}
      />
      <path
        d="M72.0599 8.54004C76.2699 5.73004 75.9399 1.92993 75.9399 1.92993H1.71993C1.71993 1.92993 1.38993 5.73004 5.59993 8.54004C9.33993 11.03 6.50993 15.48 4.76993 15.48C4.76993 15.48 5.67993 19.03 9.71993 18.2C9.71993 18.2 7.07993 23.3999 12.5299 24.5599C12.5299 24.5599 11.5399 33.89 22.7699 32.4H54.8799C66.1099 33.89 65.1199 24.5599 65.1199 24.5599C70.5699 23.3999 67.9299 18.2 67.9299 18.2C71.9799 19.03 72.8799 15.48 72.8799 15.48C71.1499 15.47 68.3299 11.03 72.0599 8.54004Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
